// in src/posts.js
import * as React from 'react';
import { Blog } from '../types';
import { TopToolbar,Show, useListContext, List, TextField, DateField, ReferenceField, EditButton, Pagination, useShowController } from 'react-admin';
import { Card, CardActions, CardContent, CardHeader, Avatar, Grid } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';

import { Button, Toolbar } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { getTsBuildInfoEmitOutputFilePath } from 'typescript';
import parse, { attributesToProps } from 'html-react-parser';
import Moment from 'moment';
import ClubBlack from './ClubBlack.png'


const options = {
    replace: domNode =>
    {
        if (domNode.attribs && domNode.name === 'main')
        {
            const props = attributesToProps(domNode.attribs);
            return <div {...props} />;
        }
    }
};



const BlogShow1 = (props) =>
{
    // const record = useShowController(props)
    const classes = useStyles();

    const controller = useShowController(props);

    const { record } = controller;
    const { id, location } = props;

    // const ref = React.useRef([]);


    if (!record) return null;
    return (
        // <div className={classes.root}>
        <Paper className={classes.paper} key={record.id}>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={9} md={12} >
                    <Typography gutterBottom variant="subtitle1">
                        {Moment(record.creationDate).format('DD.MM.yyyy')}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={9} md={12}>
                    <Typography gutterBottom variant="h5">
{record.title}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={9} md={12}>
                    <ButtonBase className={classes.image}>
                        <img className={classes.img} alt="complex" src={ClubBlack} />
                    </ButtonBase>
                </Grid>
                <Grid item xs={12} sm={9} md={12}>

                    <Typography variant="body2" gutterBottom>
                        {
                            parse(record.new.replace('///',''), options)}


                    </Typography>

                </Grid>
            </Grid>
        </Paper>
        //  </div>
    );
};

const ListActions = (props) => (
    <TopToolbar>
  
    </TopToolbar>
  );

export const BlogShow = (props) => (
    <Show {...props}  actions={<ListActions />}>
        <BlogShow1 id='SS'  {...props} />
    </Show>
);

const useStyles = makeStyles((theme) =>
createStyles({
    root: {
        flexGrow: 1,
        width: '500',
        //margin:'0 auto',
  
      },
  
    spacer: { height: 20 },
    invoices: { margin: '10px 0' },
    paper: {
        padding: theme.spacing(1),
        margin: 10,
        // maxWidth: 1000,
        // width: '100%',
        backgroundColor: '#F7F7F7',
        // display: 'flex',
        // justifyContent:'center'
      },
}));